const CountriesContactInfo = [
  {
    name: "United Kingdom",
    phonenumber: "+44 (0)333 344 1225",
    salesemail: "sales@electedtechnologies.co.uk",
    supportemail: "support@electedtechnologies.co.uk",
    address: [
      "Elected Technologies",
      "2nd Floor, Astech Mill",
      "Stratford Road",
      "Shipston on Stour",
      "Warwickshire",
      "CV36 4BA"
    ]
  },
  {
    name: "Ireland",
    salesemail: "sales@electedtechnologies.com",
    supportemail: "support@electedtechnologies.com",
    address: []
  },
  {
    name: "Australia",
    phonenumber: "+61 (0)2 6169 1019",
    salesemail: "sales@electedtechnologies.com",
    supportemail: "support@electedtechnologies.com",
    address: [
      "Elected Technologies",
      "Level 1, The Realm",
      "18 National Circuit",
      "Barton, ACT 2600"
    ]
  },
  {
    name: "New Zealand",
    salesemail: "sales@electedtechnologies.com",
    supportemail: "support@electedtechnologies.com",
    address: []
  }
];

export default CountriesContactInfo;



// WEBPACK FOOTER //
// ./src/content/countriesContactInfo.js